export class TranslationsDto {
    id:string;
    es:string;
    en:string;
    page:string;
}
